<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Print Customer Quotation</h2>
                  <div style="border: 1px solid black">
  
                    <!-- PRINT WO START -->
                    <div id="printMe" v-if="dataReady">
                        <div style="background-color:#fff">
                        <print-header></print-header>
                        <hr>
                        <h3 class="pl-5 pr-5">Customer Quotation</h3>
                        <!-- <h3 class="pl-5 pr-5">Quotation {{ detailId }}</h3> -->
                        <!-- <hr> -->

                        <div class="row mt-3 mb-3 pl-5 pr-5 ">
                          <div class="col-md-6 col-12 row ">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Nomor Referensi</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{detailId}}</label>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 row">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Nomor Telefon</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{data.phone_number}}</label>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 row">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Nama Pelanggan</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{data.name}}</label>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 row">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Tipe Kendaraan</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{data.car_name}}</label>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 row">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Merek Kendaraan</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{data.car_brand_name}}</label>
                            </div>
                          </div>
                          <div class="col-md-6 col-12 row">
                            <div class="col-5">
                              <label style=" font-size: 16px;text-align: left !important;">Nomor Polisi</label>
                            </div>
                            <div class="col-1">
                              <label style=" font-size: 16px;text-align: left !important;">:</label>
                            </div>
                            <div class="col-6">
                              <label style=" font-size: 16px;text-align: left !important;">{{data.registration}}</label>
                            </div>
                          </div>

                          <!-- <div class="col-md text-center">
                            <label class="font-weight-bold" for="partshopCode">Merk Mobil</label>
                            <h4>{{ data.car_brand_name }}</h4>
                          </div>
                          <div class="col-md text-center" >
                            <label class="font-weight-bold" for="partshopCode">Tipe Mobil</label>
                            <h4>{{ data.car_name }}</h4>
                          </div>
                          <div class="col-md text-center" >
                            <label class="font-weight-bold" for="partshopCode">Nama Pelanggan</label>
                            <h4>{{ data.name }}</h4>
                          </div>
                          <div class="col-md text-center">
                            <label class="font-weight-bold" for="partshopCode">No Telfon Customer</label>
                            <h4>{{ data.phone_number }}</h4>
                          </div>
                          <div class="col-md text-center">
                            <label class="font-weight-bold" for="partshopCode">Plat Nomor Mobil</label>
                            <h4 v-if="data.registration">{{ data.registration }}</h4>
                            <h4 v-else>-</h4>
                          </div> -->
                          <!-- <div class="col-md-4 text-center"  >
                            <label class="font-weight-bold" for="partshopCode">Harga Total</label>
                            <h3>Rp. {{ numberWithCommas(overallTotal) }}</h3>
                          </div> -->
                        </div>
                        <!-- <div class="row mb-3">
                          
                        </div> -->

                        
                        <div class="pl-5 pr-5">
                          <h4 class="mt-4 ml-1 mb-3">Part</h4>
                          <!-- <table class="table text-center" style="font-size:14px">
                              <thead style="background-color : #979797 !important;">
                                  <tr>
                                  <th>No</th>
                                  <th>Sparepart</th>
                                  <th>Deskripsi</th>
                                  <th>Jumlah</th>
                                  <th>Harga Satuan</th>
                                  <th>Harga Total</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(sparepart, index) in data.spareparts.filter(x => x.sparepart_type == 2)" style="background-color : #f2f4f5 !important;">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ sparepart.sparepart_name ? sparepart.sparepart_name : '-' }}</td>
                                    <td>{{ sparepart.part_number ? sparepart.part_number : '-' }}</td>
                                    <td>{{ numberWithCommas(sparepart.quantity) }}</td>
                                    <td>Rp. {{ numberWithCommas((sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : sparepart.estimated_price)) }}</td>
                                    <td>Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : sparepart.estimated_price)) }}</td>
                                  </tr>
                                  <tr v-if="data.spareparts.filter(x => x.sparepart_type == 2).length == 0">
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>X</td>
                                  </tr>
                              </tbody>
                          </table> -->

                          <div class="row mr-1 ml-1" style="background-color : #979797 !important;font-size:14px;padding:0.9em">
                            <div class="col-md">
                              <th>No</th>
                            </div>
                            <div class="col-md">
                              <th>Sparepart</th>
                            </div>
                            <div class="col-md">
                              <th>Deskripsi</th>
                            </div>
                            <div class="col-md">
                              <th>Jumlah</th>
                            </div>
                            <div class="col-md">
                              <th>Harga Satuan</th>
                            </div>
                            <div class="col-md">
                              <th>Harga Total</th>
                            </div>
                          </div>

                          <div>
                            <div class="row mr-1 ml-1" v-for="(sparepart, index) in data.spareparts.filter(x => x.sparepart_type == 2 && !x.deleted_at)" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
                              <div class="col-md">
                                {{ index+1 }}
                              </div>
                              <div class="col-md">
                                {{ sparepart.sparepart_name ? sparepart.sparepart_name : '-' }}
                              </div>
                              <div class="col-md">
                                {{ sparepart.part_number ? sparepart.part_number : '-' }}
                              </div>
                              <div class="col-md">
                                {{ numberWithCommas(sparepart.quantity) }}
                              </div>
                              <div class="col-md">
                                Rp. {{ numberWithCommas((sparepart.estimated_price ? sparepart.estimated_price : 0)) }}
                              </div>
                              <div class="col-md">
                                Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.estimated_price ? sparepart.estimated_price : 0)) }}
                              </div>
                            </div>
                            <div class="row mr-1 ml-1" v-if="data.spareparts.filter(x => x.sparepart_type == 2).length == 0" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                X
                              </div>
                            </div>
                          </div>

                          <!-- <div class="mt-3 bg-grey row p-3 ml-1 mr-1">
                            <div class="col-md text-left">
                               <h5>Total Harga Part</h5>
                            </div>
                            <div class="col-md text-right">
                              <h5>Rp. {{sum(data.spareparts.filter(x => x.sparepart_type == 2).map(x => x.quantity * (x.supplier_prices ? x.supplier_prices[0].price_per_item : x.estimated_price)))}}</h5>
                            </div>
                          </div> -->
                          <div class="row  mt-4 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
                            <div class="col-md text-left">
                              <label style=" font-size: 16px;text-align: left !important;">Total Harga Part</label>
                            </div>
                            <div class="col-md text-right">
                              <label style=" font-size: 16px;text-align: right !important;">Rp. {{sum(data.spareparts.filter(x => x.sparepart_type == 2).map(x => x.quantity * (x.estimated_price ? x.estimated_price : 0)))}}</label>
                            </div>
                          </div>
                        </div>

                        <div class="pl-5 pr-5">
                          <h4 class="mt-3 mb-3 ml-1">Jasa</h4>

                          <!-- <table class="table table-striped text-center" style="font-size:14px">
                              <thead style="background-color : #979797 !important;">
                                  <tr>
                                  <th>No</th>
                                  <th>Sparepart</th>
                                  <th>Deskripsi</th>
                                  <th>Jumlah</th>
                                  <th>Harga Satuan</th>
                                  <th>Harga Total</th>
                                  </tr>
                              </thead>
                              <tbody >
                                  <tr v-for="(sparepart, index) in data.spareparts.filter(x => x.sparepart_type == 1)" style="background-color : #f2f4f5 !important;">
                                  <td>{{ index+1 }}</td>
                                  <td>{{ sparepart.sparepart_name ? sparepart.sparepart_name : '-' }}</td>
                                  <td>{{ sparepart.part_number ? sparepart.part_number : '-' }}</td>
                                  <td>{{ numberWithCommas(sparepart.quantity) }}</td>
                                  <td>Rp``. {{ numberWithCommas(sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : sparepart.estimated_price) }}</td>
                                  <td>Rp. {{ numberWithCommas(sparepart.quantity *(sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : sparepart.estimated_price)) }}</td>
                                  </tr>
                                  <tr v-if="data.spareparts.filter(x => x.sparepart_type == 1).length == 0">
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>X</td>
                                  </tr>
                              </tbody>
                          </table> -->
                          <div class="row mr-1 ml-1" style="background-color : #979797 !important;font-size:14px;padding:0.9em">
                            <div class="col-md">
                              <th>No</th>
                            </div>
                            <div class="col-md">
                              <th>Sparepart</th>
                            </div>
                            <div class="col-md">
                              <th>Tipe</th>
                            </div>
                            <div class="col-md">
                              <th>Deskripsi</th>
                            </div>
                            <div class="col-md">
                              <th>Jumlah</th>
                            </div>
                            <div class="col-md">
                              <th>Harga Satuan</th>
                            </div>
                            <div class="col-md">
                              <th>Harga Total</th>
                            </div>
                          </div>

                          <div>
                            <div class="row mr-1 ml-1" v-for="(sparepart, index) in data.spareparts.filter(x => x.sparepart_type == 1 && !x.deleted_at)" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
                              <div class="col-md">
                                {{ index+1 }}
                              </div>
                              <div class="col-md">
                                {{ sparepart.sparepart_name ? sparepart.sparepart_name : '-' }}
                              </div>
                              <div class="col-md">
                                {{ sparepart.type ? sparepart.type : '-' }}
                              </div>
                              <div class="col-md">
                                {{ sparepart.part_number ? sparepart.part_number : '-' }}
                              </div>
                              <div class="col-md">
                                {{ numberWithCommas(sparepart.quantity) }}
                              </div>
                              <div class="col-md">
                                Rp. {{ numberWithCommas((sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : 0)) }}
                              </div>
                              <div class="col-md">
                                Rp. {{ numberWithCommas(sparepart.quantity * (sparepart.supplier_prices ? sparepart.supplier_prices[0].price_per_item : 0)) }}
                              </div>
                            </div>

                            <div class="row mr-1 ml-1" v-if="data.spareparts.filter(x => x.sparepart_type == 1).length == 0" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                -
                              </div>
                              <div class="col-md">
                                X
                              </div>
                            </div>
                          </div>

                          <!-- <div class="mt-3 bg-grey row p-3 ml-1 mr-1">
                            <div class="col-md text-left">
                               <h5>Total Harga Jasa</h5>
                            </div>
                            <div class="col-md text-right">
                              <h5>Rp. {{sum(data.spareparts.filter(x => x.sparepart_type == 1).map(x => x.quantity * x.supplier_prices[0].price_per_item))}}</h5>
                            </div>
                          </div> -->
                          <div class="row  mt-4 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
                            <div class="col-md text-left">
                              <label style=" font-size: 16px;text-align: left !important;">Total Harga Jasa</label>
                            </div>
                            <div class="col-md text-right">
                              <label style=" font-size: 16px;text-align: right !important;">Rp. {{sum(data.spareparts.filter(x => x.sparepart_type == 1).map(x => x.quantity *(x.supplier_prices ? x.supplier_prices[0].price_per_item : 0)))}}</label>
                            </div>
                          </div>
                        </div>

                        <hr>

                        <div class="row  mt-2 p-3 mr-5 ml-5" style="background-color : #f2f4f5 !important;">
                          <div class="col-md text-left">
                            <label style=" font-size: 16px;text-align: left !important;">PPN</label>
                          </div>
                          <div class="col-md text-right">
                            <label style=" font-size: 16px;text-align: right !important;">Rp. {{numberWithCommas(this.data.ppn)}}.00</label>
                          </div>
                        </div>
                        <div class="row  mt-3 p-3 mr-5 ml-5" style="background-color : #f2f4f5 !important;">
                          <div class="col-md text-left">
                            <label style=" font-size: 16px;text-align: left !important;">Subtotal</label>
                          </div>
                          <div class="col-md text-right">
                            <label style=" font-size: 16px;text-align: right !important;">Rp. {{numberWithCommas(this.data.ppn + overallTotal)}}.00</label>
                          </div>
                        </div>

                        <!-- <h5 class="text-right ml-5 p-3 mt-3 mb-3 mr-5 bg-grey"> </h5> -->
                        <!-- <h5 class="text-right ml-5 p-3 mt-3 mb-3 mr-5 bg-grey">Subtotal : Rp. {{numberWithCommas(this.data.ppn + overallTotal)}}.00</h5> -->
                        
                        

                        <div class="mt-5 mb-5 pl-5 pr-5">
                            
                          <div class="row">
                            <div class="col-5 pl-5 pr-5 w-75" >
                              <h5 class="text-center" style="font-size:14px">Jakarta , {{moment().format('MMMM DD, YYYY')}}</h5>
                              <h5 class="text-center" style="font-size:14px">Yang Menyutujui,</h5>
                              <div style="border-bottom: 1px solid black;margin-top:75px !important" class="mb-3">
                              </div>
                              <h5 class="text-center">{{data.name}}</h5>

                            </div>
                            <div class="offset-2 col-5 pl-5 pr-5">
                              <h5 style="color:white;">_</h5>
                              <h5 style="color:white;">_</h5>
                              <div style="border-bottom: 1px solid black;margin-top:75px !important" class="mb-3">
                              </div>
                              <h5 class="text-center">{{user.display_name}}</h5>
                            </div>
                          </div>
                        </div>
                        </div>
                    </div>
                    <!-- PRINT WO END -->
  
                  </div>
                  <div class="row mt-3">
                    <div class="col-12 text-center">
                      <button class="btn btn-info mr-3" style="width: 75px;" @click="printPage">Print</button>
                      <button class="btn btn-primary" style="width: 75px;" @click="$emit('closeModal')">Kembali</button>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import printHeader from '@/components/print/print_header.vue'
    import moment from 'moment'
  
    export default {
        data () {
            return {
                mobile : this.isMobile(),
                data : null,
                dataReady : false,
                moment,
				user : this.$store.getters.currentUser
            }
        },
        props : ['detailId'],
        components:{
            printHeader,
        },
        mounted () {
            this.getQuotationDetail();
        },
        computed : {
           overallTotal(){
            if(this.data != null){
              var total = 0;
              for(var i in this.data.spareparts){
                if(this.data.spareparts[i].sparepart_type == 1)
                  total += (this.data.spareparts[i].supplier_prices ? this.data.spareparts[i].supplier_prices[0].price_per_item : 0)* this.data.spareparts[i].quantity
                else
                  total += (this.data.spareparts[i].estimated_price ? parseInt(this.data.spareparts[i].estimated_price) : 0) * this.data.spareparts[i].quantity
              }
              return total;
            } else {
              return null;
            }
          }
        },
        methods : {
          calculatePPN() {
            let ppn = 0

            for(var i = 0 ; i < this.data.spareparts.length ; i++) {
              let sparepart = this.data.spareparts[i]
              console.log(sparepart)

              if(!sparepart.supplier_prices) continue;

              if(sparepart.supplier_prices[0].ppn_included || sparepart.supplier_prices[0].without_ppn)
                ppn += 0
              else {
                ppn += parseFloat(sparepart.supplier_prices[0].price_per_item) * 0.11
              }
            }

            this.data.ppn = ppn
          },
            printPage(){

              let styles = {
                name: '_blank',
                specs: [
                  'fullscreen=yes',
                  'titlebar=yes',
                  'scrollbars=yes'
                ],
                styles : [
                  'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
                  'https://unpkg.com/kidlat-css/css/kidlat.css',
                  '/quotation.css'
                ]
              }
                this.$htmlToPaper('printMe' , styles);
            },
            getQuotationDetail(){
                this.$http.get(`/api/v1/quotation/${this.detailId}`)
                .then((resp)=>{
                    this.data = resp.data.data;
                    this.data.spareparts = this.data.spareparts.filter(x => !x.deleted_at)
                    this.calculatePPN()
                })
                .then(()=>{
                    this.matchCar();
                })
                .then(()=>{
                    this.dataReady = true;
                })
                .catch((err)=>{
                    console.log(err);
                })
            },
            matchCar(){
                let car = this.$store.getters.getModelDetailById(this.data.car_id)
                this.data.car_brand_name = car.brand_name
                this.data.car_name = car.name
            },
            sum(data) {
              let total = 0

              for(var i = 0 ; i < data.length ; i++) {
                total += data[i]
              }

              return this.numberWithCommas(total)
            }
        }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  
  
  .companyDetails{
    margin-bottom: 5px;
    font-size:.6rem;
  }
  /* .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  } */
  .contentTitle{
    margin-top:8px;
    font-size:14px;
    font-weight: 700;
  }
  .contentVariable{
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
  }


  
  
  </style>